import { rem } from './layout';

const normal = rem(4);

export default {
  normal,
};
